import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { avatar, close_modal, deleteIcon, green_plus_icon } from '../../assets/img';
import { handleShowCTForProposal } from '../../utils/helper';
import Spinner from '../Loading/Spinner';
import styles from './positions-comparison.module.scss';
import SearchSuccessorComparison from '../SearchSuccessorComparison/SearchSuccessorComparison';
import { cloneDeep, isEmpty, size } from 'lodash';
import styled from 'styled-components';
import UserCareerTable from '../../pages/PDCMeeting/PdcProposalList/components/UserCareerTable/UserCareerTable';
import { Checkbox, Input, Modal, Pagination } from 'antd';
import { BasicButton } from '../../assets/common';
import { pushMessage } from '../../store/alertMessageSlice';
import GlobalAlertMessage from '../GlobalAlertMessage/GlobalAlertMessage';
import { CustomNumber, Text } from '../ComplementaryExperience/complementaryExperienceStyled';
import { pdcMeetingApi } from '../../services/pdcMeetingApi';
import AddNewExperience from '../TalentsComparison/AddNewExperience/AddNewExperience';
import { ModelTC } from '../Model';
import moment from 'moment';
import RichTextEditor from '../RichTextEditor/RichTextEditor';
import { ContentState, convertToRaw, EditorState } from 'draft-js';

const PositionsComparison = (props) => {
  const {
    isPopupTalentComparison,
    setIsPopupTalentComparison,
    mobilityId,
    isOnlyViewAgenda,
    mobilityDetails,
    mobilityProposalId,
    fetchMobility,
    currentProposalList,
    isPosition = false,
    isLoading,
    fetchMobilityDetails,
    comparedPosition,
  } = props;
  const dispatch = useDispatch();
  const userInfos = useSelector((state) => state.user);
  const { roleId } = useSelector((state) => state.user.roleActive);
  const [data, setData] = useState({
    limit: 3,
    total: 0,
    page: 1,
  });
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [compareData, setCompareData] = useState({
    initData: [],
    currentData: [],
  });
  const [isShowPopupConfirm, setIsShowPopupConfirm] = useState(false);
  const [proposalList, setProposalList] = useState([]);
  const [experience, setExperience] = useState([]);
  const isInit = useRef(false);
  const isChangeDedicated = useRef(false);

  useEffect(() => {
    if ((isInit.current && !proposalList?.length) || isChangeDedicated.current) {
      return;
    }

    setCompareData(() => ({
      initData: !isEmpty(proposalList) ? cloneDeep(proposalList) : [],
      currentData: !isEmpty(proposalList) ? cloneDeep(proposalList) : [],
    }));
    isInit.current = true;
  }, [proposalList]);

  const isChangeSuccessorList = useMemo(() => {
    return JSON.stringify(compareData.initData) !== JSON.stringify(compareData.currentData);
  }, [compareData]);

  useEffect(() => {
    if (!compareData?.currentData) return;
    setExperience(!isEmpty(compareData?.currentData) ? cloneDeep(compareData?.currentData) : []);
  }, [compareData.currentData]);

  // Update pagination
  useEffect(() => {
    const tempLength = proposalList?.length;
    setData((prev) => ({
      ...prev,
      total: tempLength,
      limit: tempLength === 4 ? 2 : 3,
    }));
  }, [proposalList]);

  const fetchTalentDetails = async (record) => {
    const talents = !isEmpty(proposalList) ? cloneDeep(proposalList) : [];
    const listIdTalent = !isEmpty(talents) ? talents.map((talent) => talent.staffId) : [];
    if (listIdTalent.includes(record?.staffId)) {
      dispatch(
        pushMessage({
          message: `Talent has already been added`,
          type: 'error',
          timeShow: 5000,
          containerId: 'SUCCESSOR_COMPARISION',
        }),
      );
      return;
    }
    try {
      setLoading(true);
      const response = await pdcMeetingApi.getStaffDetails(record?.staffId || record?.staff_id);
      if (response.status === 200) {
        const result = response?.data?.result[0] || {};

        const isTalentInProposalList = proposalList.some((talent) => talent.staff_id === result?.staffId);

        if (isTalentInProposalList) {
          dispatch(
            pushMessage({
              message: `Talent has already been added`,
              type: 'error',
              timeShow: 5000,
              containerId: 'SUCCESSOR_COMPARISION',
            }),
          );
          return;
        }

        const newTalent = {
          id: result?.staffId || '',
          mobility_id: mobilityId,
          staff_id: result?.staffId || '',
          remarks: null,
          type: 'talent',
          division: result?.currentPosition?.division || '',
          opu_name: result?.currentPosition?.opu_name || '',
          business_unit: result?.currentPosition?.business_unit || '',
          card_type: 'talent',
          position_name: result?.currentPosition?.position_name || '',
          image_url: result?.image || '',
          birth_name: result?.birthName || '',
          age: result?.age || 0,
          top_talent_status: result?.talentCategory || null,
          job_grade: result?.jp || '',
          role_level: result?.roleLevel || '',
          sg: result?.sg || '',
          date_in_sg: result?.yearsInSg || '',
          date_in_position: result?.years_in_position || '',
          retirement_or_contract: result?.retirementOrContract || '',
          proposal_settings: null,
          proposal_type: null,
          proposal_type_name: null,
          proposal_mobility_id: null,
          readiness: null,
          rating: !isEmpty(result?.rating) && result?.rating.length > 0 ? result?.rating.map((r) => ({ ...r, year_bepcb: r?.year || '' })) : [],
          keystrength: '',
          dev_area: '',
          experiences: [],
          jg: result?.jp || '',
          position_code: result?.currentPosition?.position_code || '',
        };

        isChangeDedicated.current = true;

        setCompareData((prev) => ({
          ...prev,
          currentData: [...prev.currentData, { ...newTalent, order: prev?.currentData?.length + 1 }],
        }));
        setProposalList((prev) => [
          ...prev,
          {
            ...newTalent,
            order: prev?.length + 1,
          },
        ]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const addTalent = async (val) => {
    if (!val?.staffId) return;
    await fetchTalentDetails(val);
  };

  const onDeleteProfile = (item) => {
    const index = proposalList.findIndex((talent) => (talent?.staff_id || talent?.staffId) === (item?.staff_id || item?.staffId));
    if (index > -1) {
      isChangeDedicated.current = true;
      const talentList = cloneDeep(proposalList) || [];
      const result = talentList.filter((talent) => (talent?.staff_id || talent?.staffId) !== (item?.staff_id || item?.staffId));
      setData((prev) => ({
        ...prev,
        page: result?.length !== 4 && result?.length % 3 === 0 && prev?.page > 1 ? prev?.page - 1 : prev?.page,
      }));
      setCompareData((prev) => ({
        ...prev,
        currentData: result,
      }));
      setProposalList(result);
    }
  };

  const fromResult = (data.page - 1) * data.limit + 1;
  const toResults = data.page * data.limit;

  const getExperiencesToUpdate = (items, checkedItems) => {
    const tempCheckedItems = !isEmpty(checkedItems) ? checkedItems.map((i) => i.value) : [];
    let tempItems = [];
    if (!isEmpty(items)) {
      tempItems = items.map((item) => {
        if (tempCheckedItems.includes(item?.value)) {
          return { ...item, checked: true };
        } else {
          return { ...item, checked: false };
        }
      });
    }
    return tempItems;
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const data = !isEmpty(proposalList)
        ? proposalList.map((item, index) => {
            const experienceList = experience.filter((exp) => exp?.staff_id === (item?.staffId || item?.staff_id))[0] || {};
            const firstItem = isPosition ? currentProposalList?.talents?.at(0) : currentProposalList?.positions?.at(0);

            return {
              mobility_id: mobilityId,
              mobility_proposals_id: mobilityProposalId,
              staff_id: item?.staffId || item?.staff_id,
              staff_id_compare: firstItem?.staffId || firstItem?.staff_id,
              experiences: getExperiencesToUpdate(experienceList.experiences, experienceList.experiences_checked),
              keystrength: item?.keystrength || '',
              dev_area: item?.dev_area || '',
              order: index + 1,
            };
          })
        : [];
      const res = await pdcMeetingApi.createOrUpdateSuccessorList({ data, roleId, userInfos });

      if (res.status === 200) {
        dispatch(
          pushMessage({
            message: `Your changes has been saved successfully`,
            type: 'success',
            timeShow: 5000,
            containerId: 'SUCCESSOR_COMPARISION',
          }),
        );

        await handleFetchProposalList();

        const currentProposalList = proposalList.map((item) => {
          const experienceList = experience.filter((exp) => exp?.staff_id === (item?.staffId || item?.staff_id))[0] || {};
          return {
            ...item,
            experiences: getExperiencesToUpdate(experienceList.experiences, experienceList.experiences_checked),
          };
        });

        setCompareData(() => ({
          initData: !isEmpty(currentProposalList) ? cloneDeep(currentProposalList) : [],
          currentData: !isEmpty(currentProposalList) ? cloneDeep(currentProposalList) : [],
        }));
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      isChangeDedicated.current = false;
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleSaveTalentComparison = async () => {
    const body = {
      title: mobilityDetails?.title || '',
      advocators:
        !isEmpty(mobilityDetails?.advocators) && Array.isArray(mobilityDetails?.advocators)
          ? mobilityDetails?.advocators?.map((advocator) => ({
              label: advocator?.name || '',
              value: advocator?.id || '',
            }))
          : [],
      hr_partners:
        !isEmpty(mobilityDetails?.hr_partners) && Array.isArray(mobilityDetails?.hr_partners)
          ? mobilityDetails?.hr_partners?.map((hrPartner) => ({
              label: hrPartner?.name || '',
              value: hrPartner?.id || '',
            }))
          : [],
      status: mobilityDetails?.status || '',
      step: mobilityDetails?.step || 0,
      proposals:
        !isEmpty(mobilityDetails?.proposals) && Array.isArray(mobilityDetails?.proposals)
          ? mobilityDetails?.proposals.map((item) => {
              if (item.id.toString() !== mobilityProposalId.toString()) {
                return item;
              }

              const filteredTalentCards = proposalList.filter(
                (talent) => !item?.cards?.some((card) => card?.staff_id?.toString() === talent?.staff_id?.toString()),
              );

              return {
                ...item,
                cards: [
                  ...item?.cards
                    .filter(
                      (card) =>
                        proposalList.some((talent) => talent?.staff_id?.toString() === card?.staff_id?.toString()) ||
                        card?.type === (isPosition ? 'talent' : 'position'),
                    )
                    .map((card) => ({
                      id: card?.id,
                      staff_id: card?.staff_id,
                      position_code: card?.position_code,
                      order: card?.order,
                      type: card?.type,
                      successors: Array.isArray(card?.successors) ? card?.successors?.join(',') : '',
                      additional_input: card?.additional_input,
                    })),
                  ...filteredTalentCards.map((talent) => ({
                    id: null,
                    staff_id: talent?.staff_id,
                    position_code: talent?.position_code,
                    order: talent?.order + 1,
                    type: isPosition ? 'position' : 'talent',
                    successors: '',
                  })),
                ],
              };
            })
          : [],
    };

    try {
      setLoading(true);
      const res = await pdcMeetingApi.updatePdcMobility(mobilityId, body);

      if (res.status === 200) {
        await fetchMobilityDetails();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      await fetchMobility();
    }
  };

  const handleCancel = async () => {
    if (isChangeSuccessorList) {
      setIsShowPopupConfirm(true);
      return;
    }

    setProposalList([]);
    setCompareData({
      initData: [],
      currentData: [],
    });
    setIsPopupTalentComparison(null);
    isInit.current = false;
    isChangeDedicated.current = false;
  };

  const handleSaveAndExit = async () => {
    await handleSave();

    setProposalList([]);
    setCompareData({
      initData: [],
      currentData: [],
    });
    setIsPopupTalentComparison(null);
    isInit.current = false;
    isChangeDedicated.current = false;
  };

  const handleSaveBeforeExit = async () => {
    await handleSave();
    setIsShowPopupConfirm(false);
    setProposalList([]);
    setCompareData({
      initData: [],
      currentData: [],
    });
    setIsPopupTalentComparison(null);
    isInit.current = false;
    isChangeDedicated.current = false;
  };

  const handleCloseBeforeExit = () => {
    setProposalList([]);
    setCompareData({
      initData: [],
      currentData: [],
    });
    setIsPopupTalentComparison(null);
    isInit.current = false;
    isChangeDedicated.current = false;
  };

  const handleFetchProposalList = async () => {
    const newProposalList = currentProposalList;

    let newTalents = !isEmpty(newProposalList?.talents) && Array.isArray(newProposalList?.talents) ? newProposalList?.talents : [];

    if (isPosition) {
      newTalents = !isEmpty(newProposalList?.positions) && Array.isArray(newProposalList?.positions) ? newProposalList?.positions : [];
    }

    try {
      setLoading(true);
      const res = await pdcMeetingApi.getProposalDetailByPositionCodes(comparedPosition?.position_code, mobilityId, mobilityProposalId);

      if (res.status === 200) {
        const data = res?.data?.result;

        let tempProposalList = newTalents;

        if (!isEmpty(data) && Array.isArray(data)) {
          const formatDate = (date) => (date ? moment(date).format('DD/MM/YYYY') : '');

          const formatTalent = (talent) => ({
            ...talent,
            jg: `${talent?.job_grade || ''} ${formatDate(talent?.date_in_position)}`.trim(),
            sg: `${talent?.sg || ''} ${formatDate(talent?.date_in_sg)}`.trim(),
            retirement_or_contract: formatDate(talent?.retirement_or_contract),
          });

          tempProposalList = data.map((newTalent) => {
            return formatTalent(newTalent);
          });
        }

        setProposalList(tempProposalList);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isPopupTalentComparison) {
      return;
    }

    handleFetchProposalList();
  }, [isPopupTalentComparison, currentProposalList]);

  const compareItem = useMemo(() => {
    if (!isEmpty(currentProposalList)) {
      const firstItem = comparedPosition;

      if (firstItem) {
        return {
          position_name: firstItem?.position_name || '',
          opu_name: firstItem?.opu_name || '',
        };
      }
    }
    return null;
  }, [currentProposalList]);

  return (
    <>
      <CustomModal open={isPopupTalentComparison} width={1250} footer={null} onCancel={handleCancel}>
        <div className={styles.modalWrapper}>
          <div className={styles.modal_header}>
            <h1 data-testid="view-talent-comparison-title">
              {`Successors for the position ${
                compareItem?.position_name ? `of ${compareItem?.position_name} ${compareItem?.opu_name ? `, ${compareItem?.opu_name}` : ''}` : ''
              }`}
            </h1>
          </div>

          <GlobalAlertMessage style={{ marginBottom: '20px' }} id={'SUCCESSOR_COMPARISION'} />

          {isEdit && !isOnlyViewAgenda && (
            <SearchWrapper>
              <div className="d-flex">
                <div className="col-6 p-0" style={{ maxWidth: '520px' }}>
                  <SearchSuccessorComparison placeholder="Search Talent" addTalent={addTalent} />
                </div>
              </div>
            </SearchWrapper>
          )}

          <CustomModalContent>
            {proposalList?.length > 0 &&
              proposalList
                .map((i, indx) => ({ ...i, recordNo: indx }))
                .slice(fromResult - 1, toResults)
                .map((talent) => (
                  <TalentItem
                    key={talent?.staffId || talent?.staff_id}
                    record={{ ...talent }}
                    onDeleteProfile={onDeleteProfile}
                    setIsEdit={setIsEdit}
                    isEdit={isEdit}
                    isOnlyViewAgenda={isOnlyViewAgenda}
                    setCompareData={setCompareData}
                    proposalList={proposalList}
                    experience={experience.filter((item) => item?.staff_id === (talent?.staffId || talent?.staff_id))[0] || {}}
                    setProposalList={setProposalList}
                  />
                ))}
          </CustomModalContent>

          <CustomModalFooter flex="between">
            <Text>
              Showing <CustomNumber>{fromResult}</CustomNumber> to <CustomNumber>{toResults > data.total ? data.total : toResults}</CustomNumber> of{' '}
              <CustomNumber>{data.total}</CustomNumber> results
            </Text>
            <Pagination
              style={!isEdit ? { opacity: 0.5, cursor: 'no-drop' } : { opacity: 1 }}
              current={data.page}
              pageSize={data.limit}
              total={data.total}
              onChange={(page) => {
                if (!isEdit) return;
                setData((prev) => ({ ...prev, page }));
              }}
              data-testid="pagination"
            />
          </CustomModalFooter>
          <CustomModalFooter>
            {!isEdit && (
              <BasicButton width="100px" mode="teal" onClick={() => setIsEdit(true)} disabled={isLoading}>
                Edit
              </BasicButton>
            )}
            {isEdit && !isOnlyViewAgenda && (
              <>
                <BasicButton onClick={handleCancel} disabled={isLoading}>
                  Cancel
                </BasicButton>
                <BasicButton width="100px" mode="teal" onClick={handleSave} disabled={isLoading}>
                  Save
                </BasicButton>
                <BasicButton width="110px" mode="teal" onClick={handleSaveAndExit} disabled={isLoading}>
                  Save & Exit
                </BasicButton>
              </>
            )}
          </CustomModalFooter>
        </div>
        {(loading || isLoading) && (
          <LoadingWrapper>
            <Spinner />
          </LoadingWrapper>
        )}
      </CustomModal>
      <ModelTC
        info={{
          type: 'withoutSaving',
          visible: isShowPopupConfirm,
          setVisible: setIsShowPopupConfirm,
          onClose: handleCloseBeforeExit,
          handleSubmit: handleSaveBeforeExit,
        }}
      />
    </>
  );
};

const TalentItem = (props) => {
  const { record, onDeleteProfile, isEdit, isOnlyViewAgenda, setCompareData, proposalList, experience, setProposalList } = props;
  const [showExperienceModal, setShowExperienceModal] = useState(false);

  const cloneListExperience = useMemo(() => {
    return !isEmpty(experience?.experiences) ? experience.experiences : [];
  }, [experience]);

  const cloneListExperienceChecked = useMemo(() => {
    return !isEmpty(experience?.experiences_checked) ? experience.experiences_checked : [];
  }, [experience]);

  const onChangeExperience = (checkedValues) => {
    setCompareData((prev) => ({
      ...prev,
      currentData: prev.currentData.map((i) => {
        if (i?.staff_id === record?.staff_id) {
          return {
            ...i,
            experiences_checked: checkedValues,
          };
        } else {
          return i;
        }
      }),
    }));
  };

  const handleConvertStringToTextEditor = (value) => {
    if (!value) return EditorState.createEmpty();

    if (typeof value === 'string') {
      try {
        const stringified = JSON.parse(value);

        if (stringified !== undefined) {
          return value;
        }
      } catch (e) {
        // If parsing fails, it means the value is not a valid JSON string, so we can proceed to convert it to EditorState
        const contentState = ContentState.createFromText(value);
        const editorState = EditorState.createWithContent(contentState);
        const rawContent = convertToRaw(editorState.getCurrentContent());
        const stringifiedRawContent = JSON.stringify(rawContent);
        return stringifiedRawContent;
      }
    }

    return value;
  };

  return (
    <TalentItemWrap
      style={{
        width: '100%',
        flex: '1 1 0%',
      }}
    >
      <div className="topHead">
        <span className="title">Successor #{record?.recordNo + 1} Talent Information</span>
        {isEdit && proposalList?.length > 1 && !isOnlyViewAgenda && (
          <img src={close_modal} className={`deleteIcon`} onKeyDown={() => {}} onClick={() => onDeleteProfile(record)} alt="delete" />
        )}
      </div>

      <div className="contentWrap">
        <div className="talentInfo">
          <div className="sectionItem firstSection">
            <div className="avatar">
              <img
                src={record?.image_url ? record?.image_url : avatar}
                alt="avatar_profile"
                width="137"
                height="137"
                style={{ borderRadius: '100px' }}
              />
            </div>

            <div className="name">
              <div className="talentName">{`${record?.birth_name || ''} ${
                record?.top_talent_status ? `(${handleShowCTForProposal(record?.top_talent_status)})` : ''
              }`}</div>
              <div className="positionName">{`${record?.position_name} ${record?.business_unit ? `, ${record?.business_unit}` : ''}`}</div>
            </div>
          </div>

          <div className="sectionItem talentDetail">
            <div className="subTitle">Talent Details</div>
            <div className="fieldItem">
              <span className={'greyLabel'}>{'Age'}</span>
              <span className={'normalText'}>{record?.age || '-'}</span>
            </div>
            <div className="fieldItem">
              <span className={'greyLabel'}>{'Retirement Date'}</span>
              <span className={'normalText'}>{record?.retirement_or_contract || '-'} </span>
            </div>
            <div className="fieldItem">
              <span className={'greyLabel'}>{'JG (YIP)'}</span>
              <span className={'normalText'}>{record?.jg || '-'}</span>
            </div>
            <div className="fieldItem">
              <span className={'greyLabel'}>{'SG (YiSG)'}</span>
              <span className={'normalText'}>{record?.sg || '-'}</span>
            </div>
            <div className="fieldItem">
              <span className={'greyLabel'}>{`BePCB ${!isEmpty(record?.rating) ? `'${record.rating[0].year_bepcb.slice(2)}` : ''}`}</span>
              <span className={'normalText'}>{!isEmpty(record?.rating) ? record.rating[0].description : '-'}</span>
            </div>
          </div>

          <div className="sectionItem">
            <UserCareerTable data={record?.rating || []} isSearchTalent={true} type={'SUCCESSOR'} />
          </div>
        </div>
        <div className="sectionItem">
          <div className="subTitle">Experience</div>
          {!isEmpty(cloneListExperience) && (
            <CustomCheckboxGroup key={record?.staff_id} onChange={onChangeExperience} value={cloneListExperienceChecked}>
              {cloneListExperience.map((item) => (
                <CustomCheckbox key={item?.value} value={item} disabled={!isEdit || isOnlyViewAgenda}>
                  <LabelWraper>
                    <CustomInput
                      key={item?.value}
                      disabled={!isEdit || isOnlyViewAgenda}
                      defaultValue={item.label}
                      placeholder="Enter experience"
                      onChange={(event) => {
                        const tempVal = event?.target?.value;
                        setCompareData((prev) => ({
                          ...prev,
                          currentData: prev.currentData.map((i) => {
                            if (i?.staff_id === record?.staff_id) {
                              return {
                                ...i,
                                experiences: !isEmpty(i?.experiences)
                                  ? i?.experiences.map((ex) => {
                                      if (ex.value === item.value) {
                                        return { value: ex.value, label: tempVal };
                                      } else {
                                        return ex;
                                      }
                                    })
                                  : [],
                                experiences_checked: !isEmpty(i?.experiences_checked)
                                  ? i?.experiences_checked.map((ex1) => {
                                      if (ex1.value === item.value) {
                                        return { value: ex1.value, label: tempVal };
                                      } else {
                                        return ex1;
                                      }
                                    })
                                  : [],
                              };
                            } else {
                              return i;
                            }
                          }),
                        }));
                      }}
                    />
                    {size(cloneListExperience) > 0 && isEdit && !isOnlyViewAgenda && (
                      <img
                        style={{ cursor: 'pointer' }}
                        src={deleteIcon}
                        alt=""
                        onClick={() => {
                          setCompareData((prev) => ({
                            ...prev,
                            currentData: prev.currentData.map((i) => {
                              if (i?.staff_id === record?.staff_id) {
                                return {
                                  ...i,
                                  experiences: !isEmpty(i?.experiences) ? i?.experiences.filter((ex) => ex.value !== item.value) : [],
                                  experiences_checked: !isEmpty(i?.experiences_checked)
                                    ? i?.experiences_checked.filter((ex1) => ex1.value !== item.value)
                                    : [],
                                };
                              } else {
                                return i;
                              }
                            }),
                          }));
                        }}
                      />
                    )}
                  </LabelWraper>
                </CustomCheckbox>
              ))}
            </CustomCheckboxGroup>
          )}
          {isEdit && !isOnlyViewAgenda && (
            <CustomBtn
              onClick={() => {
                setShowExperienceModal(true);
              }}
            >
              <img src={green_plus_icon} alt="" />
              Add Experience
            </CustomBtn>
          )}
        </div>
        <AddNewExperience setIsVisible={setShowExperienceModal} isVisible={showExperienceModal} setCompareData={setCompareData} />
        <div className="sectionItem">
          <div className="subTitle">Leadership Insights</div>
          <div className="fieldItem mb-12">
            <div className={'smallTitle mb-8'}>
              <span>{'Strengths'}</span>
            </div>
            <RichTextEditor
              setFieldVal={(value) => {
                if (!isEdit || isOnlyViewAgenda) return;

                setCompareData((prev) => ({
                  ...prev,
                  currentData: prev.currentData.map((i) => {
                    if (i?.staff_id === record?.staff_id) {
                      return {
                        ...i,
                        keystrength: value,
                      };
                    }

                    return i;
                  }),
                }));

                setProposalList((prev) => {
                  return prev.map((i) => {
                    if (i?.staff_id === record?.staff_id) {
                      return {
                        ...i,
                        keystrength: value,
                      };
                    }

                    return i;
                  });
                });
              }}
              fieldVal={handleConvertStringToTextEditor(record?.keystrength)}
              newStyles={{ minHeight: '120px', maxHeight: '165px' }}
              placeholder="Enter Strengths"
              maxLength={false}
              readOnly={!isEdit || isOnlyViewAgenda}
            />
          </div>

          <div className="fieldItem">
            <div className={'smallTitle mb-8'}>
              <span>{'Development Areas'}</span>
            </div>
            <RichTextEditor
              setFieldVal={(value) => {
                if (!isEdit || isOnlyViewAgenda) return;

                setCompareData((prev) => ({
                  ...prev,
                  currentData: prev.currentData.map((i) => {
                    if (i?.staff_id === record?.staff_id) {
                      return {
                        ...i,
                        dev_area: value,
                      };
                    }

                    return i;
                  }),
                }));

                setProposalList((prev) => {
                  return prev.map((i) => {
                    if (i?.staff_id === record?.staff_id) {
                      return {
                        ...i,
                        dev_area: value,
                      };
                    }

                    return i;
                  });
                });
              }}
              fieldVal={handleConvertStringToTextEditor(record?.dev_area)}
              newStyles={{ minHeight: '120px', maxHeight: '165px' }}
              placeholder="Enter Development Areas"
              maxLength={false}
              readOnly={!isEdit || isOnlyViewAgenda}
            />
          </div>
        </div>
      </div>
    </TalentItemWrap>
  );
};

const CustomModal = styled(Modal)`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0 !important;
  }
`;

const CustomModalContent = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  position: relative;
  min-height: 450px;
  gap: 16px;

  .smallTitle {
    color: #394655;
    font-family: var(--font-type-default, Inter);
    font-size: var(--font-size-body-sm, 14px);
    font-style: normal;
    font-weight: var(--font-weight-medium, 500);
    line-height: var(--font-line-height-body-sm, 20px); /* 142.857% */
    letter-spacing: var(--font-letter-spacing-body-sm, 0.25px);
  }
`;

const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
`;

const CustomModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.flex === 'between' ? 'space-between' : 'flex-end')};
  padding-top: 30px;

  button {
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const TalentItemWrap = styled.div`
  width: 50%;
  border: solid 1px #d3dee8;
  border-radius: 4px;

  .deleteIcon {
    cursor: pointer;
  }

  .topHead {
    position: relative;
    border-radius: 4px 4px 0px 0px;
    background: #d9f2f7;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;

    img {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 24px;
      height: 24px;
      padding: 5px;
    }
  }

  .contentWrap {
    padding: 24px;
  }

  .talentInfo {
    .avatar {
      margin-bottom: 10px;

      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
    }

    .talentName {
      color: var(--Emphasis-Body-N800, #3f3c4c);
      text-align: center;
      font-family: Inter;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.3px;
      margin-bottom: 10px;
    }

    .positionName {
      color: var(--Emphasis-Body-N800, #3f3c4c);
      text-align: center;
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.3px;
    }
  }

  .firstSection {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .talentDetail {
    .fieldItem {
      display: flex;
      justify-content: space-between;
    }
    .greyLabel {
      min-width: 120px;
    }
    .normalText {
      width: calc(100% -120px);
      text-align: right;
    }
  }

  .sectionItem {
    margin-bottom: 30px;
  }

  .fieldItem {
    margin-bottom: 5px;
  }

  .title {
    color: var(--Other-Colors-Typography, #000);
    text-align: center;
    font-family: var(--font-type-default, Inter);
    font-size: var(--font-size-body-md, 16px);
    font-style: normal;
    font-weight: var(--font-weight-bold, 700);
    line-height: var(--font-line-height-body-md, 24px); /* 150% */
    letter-spacing: var(--font-letter-spacing-body-md, 0.3px);
  }

  .subTitle {
    color: var(--Emphasis-Body-N800, #3f3c4c);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.3px;
    margin-bottom: 16px;
  }

  .greyLabel {
    color: #7d8c9f;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 171.429% */
  }

  .normalText {
    color: var(--Emphasis-Body-N800, #3f3c4c);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 171.429% */
  }

  .mb-8 {
    margin-bottom: 8px;
  }

  .mb-12 {
    margin-bottom: 12px;
  }
`;

const LabelWraper = styled.div`
  display: flex;
  align-items: center;
  transition: all 2s;

  img {
    visibility: hidden;
    width: 0;
  }

  &:hover {
    img {
      margin-left: 10px;
      visibility: visible;
      width: 16px;
    }
  }
`;

const CustomCheckboxGroup = styled(Checkbox.Group)`
  width: 100%;
  display: flex;
  flex-direction: column;

  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0 !important;
  }
`;

const CustomCheckbox = styled(Checkbox)`
  margin-bottom: 15px;

  span {
    width: 100%;

    &.ant-checkbox {
      width: 16px;
    }
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #00a19c;
    border-color: #00a19c;
  }
`;

const CustomInput = styled(Input)`
  &:disabled {
    border: none !important;
    background: transparent !important;
  }
  input {
    border-radius: 4px;
    border: 1px solid var(--Blue-Grays-100, #d3dee8);
    background: var(--General-White, #fff);

    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */

    &::placeholder {
      color: var(--Grays-300, #8d8d8d);
    }
  }
`;

const CustomBtn = styled.button`
  border: none;
  outline: none;
  color: #00615e;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.173px;
  text-decoration-line: underline;
  background: transparent;

  img {
    margin-right: 10px;
  }
`;

const SearchWrapper = styled.div`
  margin-bottom: 20px;
`;

export default PositionsComparison;
